import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Box, Typography, FormHelperText } from '@mui/material';
import {parsePhoneNumberFromString }from 'libphonenumber-js';

export default function PhoneNumberField({
  label,
  value,
  onChange,
  onBlur,
  error,
  touched,
  disabled=false,
  country='us',
  onCountryChange
}) {
  const isError = Boolean(error && touched);
  console.log("country============",country);
  
  let normalizedCountry = country;
  // if country is a numeric dial-code (e.g. “1”, “91”), look up its ISO2:
  if (/^\d+$/.test(country)) {
    const parsed = parsePhoneNumberFromString(`+${country}`);
    normalizedCountry = parsed?.country?.toLowerCase() || 'us';
  }
  const inputCls = disabled
    ? 'custom-phone-input custom-phone-input--disabled'
    : 'custom-phone-input';
  const buttonCls = disabled
    ? 'custom-phone-button custom-phone-button--disabled'
    : 'custom-phone-button';
  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="subtitle2" sx={{ mb: 1}}>
        {label}
      </Typography>

      <PhoneInput
        country={normalizedCountry}
        value={value}
        onChange={(val, data) => {
            onChange(val, data);
            if (onCountryChange && data?.dialCode) {
            onCountryChange(`+${data.dialCode}`, data.country);
          }
        }}
        onBlur={onBlur}
        enableSearch
        inputClass="custom-phone-input"
        buttonClass="custom-phone-button"
        containerClass="custom-phone-container"
        dropdownClass="custom-phone-dropdown"
        searchClass="custom-phone-search"
        autoFormat={false}
        disabled={disabled}
    //       format={(num) => {
    //     // US format (5551234567 → (555) 123-4567)
    //     const cleaned = num.replace(/\D/g, '');
    //     if (cleaned.length < 4) return `(${cleaned}`;
    //     if (cleaned.length < 7) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    //     return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    // }}
      />

      {isError && (
        <FormHelperText error sx={{ mt: 1 }}>
          {error}
        </FormHelperText>
      )}
    </Box>
  );
}
